/**
 * Utility for handling browser speech synthesis.
 */

export interface PrivateSpeechOptions {
    lang?: string;
    onStart?: () => void;
    onEnd?: () => void;
    onError?: (error: any) => void;
}

/**
 * Speaks the provided text using the browser's SpeechSynthesis API.
 */
export function speak(text: string, options: PrivateSpeechOptions = {}) {
    if (!('speechSynthesis' in window)) {
        console.error('Sienna: SpeechSynthesis not supported.');
        return;
    }

    if (speechSynthesis.speaking) {
        speechSynthesis.cancel();
    }

    if (!text) return;

    const { lang = 'en', onStart, onEnd, onError } = options;
    const utterance = new SpeechSynthesisUtterance(text);
    
    // Set language
    utterance.lang = lang;

    // Pick best voice for the language
    const voices = speechSynthesis.getVoices();
    const langVoice = voices.find(v => v.lang.startsWith(lang)) || voices[0];
    
    if (langVoice) {
        utterance.voice = langVoice;
    }

    // Callbacks
    if (onStart) utterance.onstart = onStart;
    if (onEnd) utterance.onend = onEnd;
    if (onError) utterance.onerror = onError;

    speechSynthesis.speak(utterance);
}

/**
 * Cancels any ongoing speech.
 */
export function stopSpeaking() {
    if ('speechSynthesis' in window) {
        speechSynthesis.cancel();
    }
}
